import * as React from "react";

const MenuIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        d="M4 6H20M4 12H14M4 18H9"
        stroke={props.stroke ? props?.stroke : "#000000"}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>{" "}
    </g>
  </svg>
);

export default MenuIcon;
